module.exports = __webpack_public_path__ + "img/icon_tb_b.6e531120.png";